import CancelablePromise from "cancelable-promise";
import { ReleaseLock } from "../../lib/utils/CancelableSemaphoreAcquire.js";
import { MediaResource } from "../player/MediaResource.js";
import { MediaGarbageCollector } from "./MediaGarbageCollector.js";

export class NullGC<PlayerType, RES extends MediaResource<PlayerType, any, any>> implements MediaGarbageCollector<PlayerType, RES> {


    constructor() {

    }

    start(): void {

    }
    addResource(resource: RES): Promise<RES> {
        return Promise.resolve(resource);    
    }
    addResourceAsync(asyncResource: CancelablePromise<RES>): CancelablePromise<RES> {
        return asyncResource;
    }

    lock(): Promise<ReleaseLock> {
        return Promise.resolve(() => {});
    }
  
}
